<template>
	<div style="padding: 10px;">
		<div >
			<!-- <div style="width: 180px;text-align: right;float: right;margin-right: 10px;">
				<el-button type="primary" @click="showimport = true" icon="el-icon-upload">导入设备和点位</el-button>
			</div> -->
			<div style="width: 180px;text-align: right;float: right;margin-right: 10px;">
				<el-button type="primary" @click="showimportfromcj = true" icon="el-icon-upload">同步采集设备点位</el-button>
			</div>
			<div style="width: 180px;text-align: right;float: right;margin-right: 10px;">
				<el-button type="primary" @click="showtaskimport = true" icon="el-icon-upload">导入导出定时任务</el-button>
			</div>
			<div style="clear: both;"></div>
		</div>
		
		<div >
			<div style="width: 42%;float: left;margin-top: 10px;margin-right: 10px;">
				<el-row :gutter="20">
					<el-col :span="8">
						<el-cascader style="width: 100%;" v-model="searchInfo.orgs" :options="allOrgTree" :props="orgtreePro"  clearable></el-cascader>
					</el-col>
					<el-col :span="8">
						<el-input clearable placeholder="按设备名称查询" v-model="searchInfo.name">
							<template slot="prepend">设备名称</template>
						</el-input>
					</el-col>
					<el-col :span="8"> 
						<div style="min-width: 240px;">
							<el-button type="primary" @click="searchDev" icon="el-icon-search">搜索</el-button>
							<!-- <el-button  icon="el-icon-refresh" @click="clearDevSearch">重置</el-button> -->
							<el-button type="primary" icon="el-icon-plus" @click="addStall">添加设备</el-button>
						</div>
					</el-col>
				</el-row>
				<div >
					<el-table highlight-current-row :data="orgDevList"  style="width: 100%"  max-height="640" @row-click="rowSelected">
					    <el-table-column fixed="left" prop="devname" label="设备名称" width="150" align="center"></el-table-column>
					    <el-table-column prop="orgid" label="所属校区"  width="100" align="center"></el-table-column>
						<el-table-column prop="controlid" label="控制器id" align="center"></el-table-column>
						<el-table-column prop="devid" label="设备id" align="center"></el-table-column>
						<!-- <el-table-column prop="iconurl" label="图标" align="center"></el-table-column> -->
						<el-table-column prop="idx" label="排序"  align="center"></el-table-column>
						<el-table-column prop="defaultshow" label="首页显示"  align="center"></el-table-column>
						<el-table-column fixed="right" prop="op" label="操作" width="120" align="center">
							<template slot-scope="scope">
								<a @click.stop="goDevDetail(scope.$index, scope.row)" title="详情" style="display:inline-block;cursor:pointer;color: #409EFF;">
									<i class="el-icon-Stall">详情</i>
								</a>
								<a @click.stop="deleteDetail(scope.$index, scope.row)" title="删除" style="display:inline-block;cursor:pointer;color: #F56C6C;margin-left: 20px;">
									<i class="el-icon-Stall">删除</i>
								</a>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div style="text-align: center;">
					<el-pagination background layout="total, prev, pager, next, sizes" :page-sizes="[10, 20, 50]" :current-page="param.page"
						:page-size="param.pagenum" :total="devTotal" @size-change="handleSizeChange" @current-change="handleCurrentChange"> </el-pagination>
				</div>
			</div>
			<div style="width: 54%;float: left;margin-top: 10px;margin-left: 10px;">
				<el-row :gutter="20">
					<el-col :span="12">
						<el-input clearable placeholder="按点位名称查询" v-model="searchPointInfo.name">
							<template slot="prepend">点位名称</template>
						</el-input>
					</el-col>
					<el-col :span="12"> 
						<div style="min-width: 200px;">
							<el-button type="primary" @click="searchDevPoint" icon="el-icon-search">搜索</el-button>
							<!-- <el-button  icon="el-icon-refresh" @click="clearDevPointSearch">重置</el-button> -->
							<el-button type="primary" icon="el-icon-plus" @click="addPointStall">添加点位</el-button>
						</div>
					</el-col>
				</el-row>
				<div >
					<el-table :data="orgDevPointList"  style="width: 100%"  max-height="640">
					    <el-table-column fixed="left" prop="name" label="点位名称" width="150" align="center"></el-table-column>
						<el-table-column prop="unit" label="单位" align="center"></el-table-column>
						<el-table-column prop="controlid" label="控制器id"  align="center"></el-table-column>
						<el-table-column prop="devid" label="设备id" align="center"></el-table-column>
						<el-table-column prop="propertyid" label="点位id" align="center"></el-table-column>
						<el-table-column prop="monitortype" label="测点类型" align="center"></el-table-column>
						<el-table-column prop="icon" label="图标" align="center"></el-table-column>
						<el-table-column prop="idx" label="排序"  align="center"></el-table-column>
						<el-table-column prop="defaultshow" label="首页显示"  align="center"></el-table-column>
						<el-table-column prop="enums" label="枚举" width="250" align="center"></el-table-column>
						<el-table-column fixed="right" prop="op" label="操作" width="120" align="center">
							<template slot-scope="scope">
								<a @click="goDevPointDetail(scope.$index, scope.row)" title="详情" style="display:inline-block;cursor:pointer;color: #409EFF;">
									<i class="el-icon-Stall">详情</i>
								</a>
								<a @click="deletePointDetail(scope.$index, scope.row)" title="删除" style="display:inline-block;cursor:pointer;color: #F56C6C;margin-left: 20px;">
									<i class="el-icon-Stall">删除</i>
								</a>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div style="text-align: center;">
					<el-pagination background layout="total, prev, pager, next, sizes" :page-sizes="[10, 20, 50]" :current-page="pointparam.page"
						:page-size="pointparam.pagenum" :total="devPointTotal" @size-change="handlePointSizeChange" @current-change="handlePointCurrentChange"> </el-pagination>
				</div>
			</div>
			<div style="clear: both;"></div>
		</div>
		
		<el-dialog @close="refrashData" :destroy-on-close="true" :title="detailTitle" width="70%" :visible.sync="detailShow">
			<DevDetail @needRefrash="needRefrash" :add="isadd" :allOrgTree="allOrgTree" :selectedset="selectset"></DevDetail>
		</el-dialog>
		<el-dialog @close="refrashPointData" :destroy-on-close="true" :title="detailPointTitle" width="70%" :visible.sync="detailPointShow">
			<DevPointDetail @needPointRefrash="needPointRefrash" :add="isPointadd" :selectedset="selectpointset"></DevPointDetail>
		</el-dialog>
		<el-dialog @close="refrashData" :destroy-on-close="true" title="导入设备和点位" width="70%" :visible.sync="showimport">
			<ImportDev @needRefrash="needRefrash" :allOrgTree="allOrgTree"></ImportDev>
		</el-dialog>
		<el-dialog :destroy-on-close="true" title="导入导出定时任务" width="70%" :visible.sync="showtaskimport">
			<div>
				<el-row :gutter="20">
					<el-col :span="8">
						<el-cascader style="width: 100%;" v-model="exportorg" :options="allOrgTree" :props="orgtreePro"  clearable></el-cascader>
					</el-col>
					<el-col :span="8">
						<el-select v-model="exporttype" filterable clearable  placeholder="请选择房间类型">
						    <el-option v-for="item in loctypeList" :key="item.id" :label="item.name" :value="item.id">
						    </el-option>
						  </el-select>
					</el-col>
					<el-col :span="8"> 
						<div style="min-width: 240px;">
							<el-button type="primary" @click="exportAirTask" icon="el-icon-download">导出</el-button>
							<el-button type="primary" icon="el-icon-upload2" @click="importAirTask">导入</el-button>
						</div>
					</el-col>
				</el-row>
				<div style="margin-top: 20px;" v-show="importtask">
					<div style="text-align: center;">
						<el-upload class="upload-demo" :limit="1" drag :action="importtaskuploadUrl" 
							:before-upload="(file) => handleBeforeUpload(file) " accept=".xlsx" :headers="uploadheader" 
							:on-success="(response, file, fileList) => handleUploadSucc(response, file, fileList)">
							<i class="el-icon-upload"></i>
							<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
							<div class="el-upload__tip" slot="tip">只能上传xlsx文件，且不超过1M</div>
						</el-upload>
					</div>
					<div style="color: #F56C6C;max-height: 300px;overflow: auto;margin-top: 10px;">
						<div v-html="errorinfo"></div>
					</div>
				</div>
			</div>
		</el-dialog>
		<el-dialog :destroy-on-close="true" title="从采集端同步" width="80%" :visible.sync="showimportfromcj">
			<div>
				<el-row :gutter="20">
					<el-col :span="5">
						<el-cascader style="width: 100%;" v-model="exportorg" :options="allOrgTree" :props="orgtreePro"  clearable></el-cascader>
					</el-col>
					<el-col :span="5">
						<el-input clearable placeholder="采集库名" v-model="gatherdbname">
							<template slot="prepend">采集库名</template>
						</el-input>
					</el-col>
					<el-col :span="6">
						<el-input clearable placeholder="控制器id" v-model="importcontrolid">
							<template slot="prepend">控制器</template>
						</el-input>
					</el-col>
					<el-col :span="6">
						<el-select v-model="airtype" filterable clearable  placeholder="请选择类型">
						    <el-option v-for="item in airtypeList" :key="item.id" :label="item.name" :value="item.id">
						    </el-option>
						</el-select>
					</el-col>
					<el-col :span="2"> 
						<div style="min-width: 120px;">
							<el-button type="primary" icon="el-icon-upload2" @click="confirmImportFrom">同步</el-button>
						</div>
					</el-col>
				</el-row>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	//import dayjs from 'dayjs'
	import { queryDevByPage, queryAllOrgTree, queryDevPointByPage, 
		deleteDevPoint, deleteDev, querySysLocTypes, syncDevPointFromGather,
		queryRealDevModelByPage } from '/static/apiUrl.js'
	import DevDetail from './devdetail'
	import DevPointDetail from './devpointdetail'
	import ImportDev from './importdev'
	import axios from 'axios'
	import { baseUrl, prefix } from '/public/baseUrl.js'
	export default {
		name : 'DevList',
		data() {
			return {
				showimport : false,
				detailShow: false,
				detailPointShow: false,
				showimportfromcj : false,
				editok : false,
				isadd : false,
				editPointok : false,
				isPointadd : false,
				showtaskimport : false,
				importtask : false,
				importtaskuploadUrl : baseUrl + prefix + localStorage.getItem("citycode") + '/api/orgdev/importOrgAirTasks',
				uploadheader : {
					Authorization: sessionStorage.getItem("authToken")
				},
				errorinfo : '',
				detailTitle: '设备详情',
				detailPointTitle: '点位详情',
				selectset: null,	
				selectpointset: null,
				exportorg : '',
				exporttype : '',
				searchInfo:{
					name: '',
					orgs : '',
				},
				searchPointInfo:{
					name: '',
					did : '',
					controlid : '',
				},
				allOrgTree : [],
				param : {
					page : 1,
					pagenum : 10,
				},
				pointparam : {
					page : 1,
					pagenum : 10,
				},
				devTotal : 0,
				devPointTotal : 0,
				orgDevList : [],
				orgDevPointList : [],
				loctypeList : [],
				orgtreePro : {
					checkStrictly: true,
					value : "id",
					label : "name",
					children : "children"
				},
				airtypeList : [
					{
						id: 'power',
						name: '电表'
					},
					{
						id: 'mdv4',
						name: '美的V4'
					},
					{
						id: 'mdv6',
						name: '美的V6'
					},
					{
						id: 'mdv8',
						name: '美的V8'
					},
				],
				airtype: '',
				importcontrolid : '',
				gatherdbname : '',
				
			}
		},
		mounted() {
			this.initData()
			this.queryDevList()
		},
		components: {
			DevDetail,
			DevPointDetail,
			ImportDev,
		},
		methods: {
			handleSizeChange(val){
				this.param.pagenum = val;
				this.queryDevList()
			},
			handleCurrentChange(val){
				this.param.page = val
				this.queryDevList()
			},
			handlePointSizeChange(val){
				this.pointparam.pagenum = val;
				this.queryDevPointList()
			},
			handlePointCurrentChange(val){
				this.pointparam.page = val
				this.queryDevPointList()
			},
			initData() {
				this.allOrgTree = []
				queryAllOrgTree().then(res => {
					if(0 == res.code){
						this.allOrgTree = res.datas
					}
				})
				this.loctypeList = []
				querySysLocTypes().then(res => {
					if(0 == res.code){
						this.loctypeList = res.datas
					}
				})
				this.airtypeList = []
				queryRealDevModelByPage({
					name:'',
					pagenum : 1 ,
					pagesize : 100
				}).then(res => {
					if( 0 == res.code){
						res.datas.data.forEach((set) => {
							this.airtypeList.push({
								id : set.code,
								name : set.name
							})
						})
					}
				})
			},
			searchDev(){
				this.param.page = 1
				this.orgDevList = []
				this.queryDevList()
			},
			searchDevPoint(){
				this.pointparam.page = 1
				this.orgDevPointList = []
				this.queryDevPointList()
			},
			clearDevSearch(){
				this.searchInfo.name = ''
				this.searchInfo.orgs = ''
				this.param.page = 1
				this.queryDevList()
			},
			clearDevPointSearch(){
				this.searchPointInfo.name = ''
				this.pointparam.page = 1
				this.queryDevPointList()
			},
			rowSelected(row, column, event){
				this.searchPointInfo.did = row.devid
				this.searchPointInfo.controlid = row.controlid
				this.clearDevPointSearch()
			},
			queryDevPointList(){
				this.orgDevPointList = []
				let orgid = ""
				if(this.searchInfo.orgs.length > 0){
					orgid = this.searchInfo.orgs[this.searchInfo.orgs.length -1]
				}
				queryDevPointByPage({
					oid : orgid,
					cid : this.searchPointInfo.controlid,
					devid : this.searchPointInfo.did,
					name : this.searchPointInfo.name,
					pagenum : this.pointparam.page ,
					pagesize : this.pointparam.pagenum
				}).then(res => {
					if(0 == res.code){
						this.devPointTotal = res.datas.totalnum
						res.datas.data.forEach((set) => {
							this.orgDevPointList.push(set)
						})
					}else{
						this.devPointTotal = 0
					}
				})
			},
			queryDevList(){
				this.orgDevList = []
				this.orgDevPointList = []
				let orgid = ""
				if(this.searchInfo.orgs.length > 0){
					orgid = this.searchInfo.orgs[this.searchInfo.orgs.length -1]
				}
				queryDevByPage({
					oid : orgid,
					name : this.searchInfo.name,
					pagenum : this.param.page ,
					pagesize : this.param.pagenum
				}).then(res => {
					//console.log(res)
					if(0 == res.code){
						this.devTotal = res.datas.totalnum
						res.datas.data.forEach((set) => {
							this.orgDevList.push(set)
						})
					}else{
						this.devTotal = 0
					}
				})
			},
			goDevDetail(idx,row){
				this.detailTitle = '设备详情'
				this.isadd = false
				this.selectset = JSON.parse(JSON.stringify(this.orgDevList[idx]))
				this.detailShow = true
			},
			goDevPointDetail(idx,row){
				this.detailPointTitle = '点位详情'
				this.isPointadd = false
				this.selectpointset = JSON.parse(JSON.stringify(this.orgDevPointList[idx]))
				this.detailPointShow = true
			},
			deleteDetail(idx,row){
				this.$confirm('此操作将删除设备 '+this.orgDevList[idx].devname+', 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					deleteDev({
						id : this.orgDevList[idx].id
					}).then(res => {
						if(0 == res.code){
							this.queryDevList()
							this.$message({
								showClose: true,
								message: "删除成功",
								type: 'success'
							});
						}else{
							this.$message({
								showClose: true,
								message: res.message,
								type: 'error'
							});
						}
					}) 
				}).catch(() => {
					console.log("取消")
				});
			},
			deletePointDetail(idx,row){
				this.$confirm('此操作将删除点位 '+this.orgDevPointList[idx].name+', 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					deleteDevPoint({
						id : this.orgDevPointList[idx].id
					}).then(res => {
						if(0 == res.code){
							this.queryDevPointList()
							this.$message({
								showClose: true,
								message: "删除成功",
								type: 'success'
							});
						}else{
							this.$message({
								showClose: true,
								message: res.message,
								type: 'error'
							});
						}
					}) 
				}).catch(() => {
					console.log("取消")
				});
			},
			addStall(){
				this.detailTitle = "添加设备"
				this.isadd = true
				this.selectset = null
				this.detailShow = true
			},
			addPointStall(){
				if(this.searchPointInfo.did == null || this.searchPointInfo.did == ''){
					this.$message({
						showClose: true,
						message: "请先选择设备",
						type: 'warning'
					});
				}else{
					this.detailPointTitle = "添加点位"
					this.isPointadd = true
					this.selectpointset =  {
						id: "",
						name: "",
						devid: this.searchPointInfo.did,
						controlid: this.searchPointInfo.controlid,
						propertyid : '',
						monitortype : '',
						icon : '',
						idx : 0,
						defaultshow : '',
						unit : '',
						enums : ''
					}
					this.detailPointShow = true
				}
			},
			needRefrash(val,isshow){
				this.editok = val
				this.detailShow = isshow
			},
			refrashData() {
				if(this.editok){
					this.queryDevList()
				}
			},
			needPointRefrash(val,isshow){
				this.editPointok = val
				this.detailPointShow = isshow
			},
			refrashPointData() {
				if(this.editPointok){
					this.queryDevPointList()
				}
			},
			exportAirTask(){
				if(this.exportorg == ''){
					this.$message({
						showClose: true,
						message: "请选择校区",
						type: 'warning'
					});
				}else{
					const loading = this.$loading({
						lock: true,
						text: '导出数据中...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					let orgid = this.exportorg[this.exportorg.length - 1]
					let filename = orgid + '空调定时开关任务.xlsx'
					let autherheader = sessionStorage.getItem("authToken")
					let citycode = localStorage.getItem("citycode")
					let cityurl = baseUrl+prefix+citycode
					axios.get(cityurl+'/api/orgdev/orgAirOpenTaskExport?oid='+orgid+'&ctype='+this.exporttype, 
					{
						headers: {
							'Content-Type': 'blob',
							Authorization: autherheader
						},
						timeout : 500000,
						responseType : 'blob'
					}).then(response => {
						loading.close();
						const url = window.URL.createObjectURL(new Blob([response.data]),{type:`'application/vnd.ms-excel';chartset=utf-8`});
						const link = document.createElement('a');
						link.href = url;
						link.setAttribute('download', filename);
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link)
						
					}).catch(err => {
						console.log(err)
						loading.close();
						this.$message({
							showClose: true,
							message: "超时",
							type: 'error'
						});
					});
				}
			},
			importAirTask(){
				this.importtask = !this.importtask
			},
			handleBeforeUpload(file){
				this.errorinfo = ''
				const isLtSize = file.size / 1024 / 1024 < 1;
				if (!isLtSize) {
					this.$message.warning("导入文件大小不能超过 1MB!");
					return false;
				}
				return file
			},
			handleUploadSucc(response,file,fileList){
				if(0 == response.code){
					this.$message({
						showClose: true,
						message: "导入完成",
						type: 'success'
					});
					if(response.message){
						this.errorinfo = response.message.replace(";","<br>").replaceAll("；","<br/>")
					}
				}else{
					this.$message.error(response.message)
				}
			},
			confirmImportFrom(){
				if(this.exportorg == ''){
					this.$message({
						showClose: true,
						message: "请选择校区",
						type: 'warning'
					});
					return;
				}
				let orgid = this.exportorg[this.exportorg.length - 1]
				if(this.gatherdbname == ''){
					this.$message({
						showClose: true,
						message: "请填写数据库名",
						type: 'warning'
					});
					return;
				}
				if(this.importcontrolid == ''){
					this.$message({
						showClose: true,
						message: "请填写控制器",
						type: 'warning'
					});
					return;
				}
				if(this.airtype == ''){
					this.$message({
						showClose: true,
						message: "请选择类型",
						type: 'warning'
					});
					return;
				}
				this.$confirm('请确认好所要同步的数据，校区、库名、控制器、类型', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					const loading = this.$loading({
						lock: true,
						text: '同步数据中...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					syncDevPointFromGather({
						oid : orgid,
						dbname : this.gatherdbname,
						controlid : this.importcontrolid,
						type : this.airtype
					}).then(res => {
						loading.close()
						if(0 == res.code){
							this.$message({
								showClose: true,
								message: "同步成功，"+res.message,
								type: 'success'
							});
						}else{
							this.$message.error(res.message)
						}
					})
				}).catch(() => {
					console.log("取消")
				});
				
			},
			
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	
</style>